import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'

import { ButtonRow, DialogContainer, ErrorMessage, Label, ReadonlyField } from './globalSettingsDialog.style'

interface GlobalSettingsDialogProps {
    inputValue: number | null
    setInputValue: (value: number | null) => void
    saveSettings: () => Promise<void>
    isSaving: boolean
    error: Error | null
    onClose: () => void
}

export const GlobalSettingsDialog: React.FC<GlobalSettingsDialogProps> = ({
    inputValue,
    setInputValue,
    saveSettings,
    isSaving,
    error,
    onClose,
}) => {
    const [inputStr, setInputStr] = useState(inputValue !== null ? String(inputValue) : '')

    useEffect(() => {
        setInputStr(inputValue !== null ? String(inputValue) : '')
    }, [inputValue])

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value
        if (/^\d*$/.test(val)) {
            setInputStr(val)
        }
    }

    const onInputBlur = () => {
        if (inputStr === '') {
            setInputValue(null)
        } else {
            setInputValue(Number(inputStr))
        }
    }

    return (
        <DialogContainer>
            {/* System Fee Input */}
            <Label>Rendszerhasználati díj (bruttó, jegyenként):</Label>
            <div style={{ position: 'relative', width: '100%' }}>
                <InputText
                    value={inputStr}
                    onChange={onInputChange}
                    onBlur={onInputBlur}
                    inputMode="numeric"
                    pattern="\d*"
                    style={{ width: '100%', padding: '0.5rem 2.5rem 0.5rem 0.5rem', fontSize: '1rem' }}
                    placeholder="0"
                />
                <span
                    style={{
                        position: 'absolute',
                        right: '0.5rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#555',
                        pointerEvents: 'none',
                    }}
                >
                    Ft
                </span>
            </div>

            <ReadonlyField>
                <span>Rendszerhasználati díj ÁFA: 27%</span> <span style={{ marginLeft: '0.5rem' }}></span>
            </ReadonlyField>

            {/* Ticket VAT info */}
            <ReadonlyField>
                <span>Jegyek ÁFA: 5%</span> <span style={{ marginLeft: '0.5rem' }}></span>
            </ReadonlyField>

            {/* Error message */}
            {error && <ErrorMessage>{error.message}</ErrorMessage>}

            {/* Action buttons */}
            <ButtonRow>
                <Button label="Mégse" className="p-button-text" onClick={onClose} />
                <Button label="Mentés" onClick={saveSettings} loading={isSaving} disabled={inputStr === ''} />
            </ButtonRow>
        </DialogContainer>
    )
}
